'use client';
const GTM_SOURCE = 'https://www.googletagmanager.com/gtm.js';

export { GTM_SOURCE };
//# sourceMappingURL=domain.js.map
